export interface ISubscriptionMock {
  id: string;
  type: 'family' | 'adult' | 'child' | 'daily' | 'gift';
  title: string;
  subtitle?: string;
  duration: string;
  durationNote: string;
  visitingHours: string;
  ageRestriction?: string;
  basePrice?: number;
  price?: number;
  additionalPersonPrice?: number;
  minimumPeople?: number;
  adultsCount?: number;
  childrenCount?: number;
  totalPrice?: number;
  isNew?: boolean;
  isBest?: boolean;
  includes: string[];
  isGroupClassesIncluded: boolean;
  minPeopleRequired?: number;
  selectionType: 'exclusive' | 'combinable';
  requiresAdult?: boolean;
  renewalPrice?: number;
  renewalDays?: number;
  note?: string;
  currentQuantity?: number;
}

export const subscriptionsMock: ISubscriptionMock[] = [
  {
    id: '46e6d6cf-5ec8-11ee-80b8-ac1f6bb3f7d3',
    type: 'family',
    title: 'Семейная карта на 1 месяц',
    subtitle: 'Для 3-го и последующих членов семьи карта по 1000 рублей!',
    duration: '30 дней',
    durationNote: '(со дня оплаты)',
    visitingHours: 'пн-вс, 7:00 - 24:00',
    ageRestriction: 'до 14 лет',
    basePrice: 23000,
    additionalPersonPrice: 1000,
    minimumPeople: 3,
    adultsCount: 2,
    childrenCount: 3,
    totalPrice: 28000,
    isNew: true,
    isBest: true,
    includes: ['gym', 'pool', 'sauna'],
    isGroupClassesIncluded: false,
    minPeopleRequired: 3,
    selectionType: 'exclusive'
  },
  {
    id: 'bfca3fe8-ebba-11eb-80d4-ac1f6bb3f7d2',
    type: 'adult',
    title: 'Взрослая карта на 3 месяца',
    duration: '90 дней',
    durationNote: '(со дня оплаты)',
    visitingHours: 'пн-вс, 7:00 - 24:00',
    ageRestriction: 'от 14 лет',
    basePrice: 23000,
    price: 23000,
    currentQuantity: 0,
    isBest: true,
    includes: ['gym', 'pool', 'sauna'],
    isGroupClassesIncluded: false,
    selectionType: 'combinable'
  },
  {
    id: '1e78a866-f365-11eb-80d4-ac1f6bb3f7d2',
    type: 'child',
    title: 'Детская карта на 3 месяца',
    subtitle: 'Не продается отдельно от взрослого!',
    duration: '90 дней',
    durationNote: '(со дня оплаты)',
    visitingHours: 'пн-вс, 7:00 - 24:00',
    ageRestriction: 'до 14 лет',
    basePrice: 23000,
    price: 23000,
    currentQuantity: 4,
    includes: ['pool', 'sauna'],
    isGroupClassesIncluded: false,
    requiresAdult: true,
    selectionType: 'combinable'
  },
  {
    id: '5a9c423f-aef4-11ea-80c1-ac1f6bb3f7d3',
    type: 'adult',
    title: 'Взрослая карта на 1 месяц',
    subtitle: 'Продлите в течение 3 дней после окончания карты за 9 000Р!',
    duration: '30 дней',
    durationNote: '(со дня оплаты)',
    visitingHours: 'пн-вс, 7:00 - 24:00',
    ageRestriction: 'от 14 лет',
    basePrice: 10000,
    price: 10000,
    currentQuantity: 10,
    includes: ['gym', 'pool', 'sauna'],
    isGroupClassesIncluded: false,
    renewalPrice: 7000,
    renewalDays: 3,
    selectionType: 'combinable'
  },
  {
    id: 'cf271fc5-aef4-11ea-80c1-ac1f6bb3f7d3',
    type: 'child',
    title: 'Детская карта на 1 месяц',
    subtitle: 'Не продается отдельно от взрослого! Продлите в течение 3 дней после окончания карты за 9 000Р!',
    duration: '30 дней',
    durationNote: '(со дня оплаты)',
    visitingHours: 'пн-вс, 7:00 - 24:00',
    ageRestriction: 'от 1 года до 13 лет',
    basePrice: 10000,
    price: 10000,
    currentQuantity: 1,
    includes: ['pool', 'sauna'],
    isGroupClassesIncluded: false,
    requiresAdult: true,
    renewalPrice: 7000,
    renewalDays: 3,
    selectionType: 'combinable'
  },
  {
    id: '5e8c8b83-ca78-11ee-80c0-ac1f6bb3f7d3',
    type: 'daily',
    title: 'Карта на 1 день',
    subtitle: 'Протестируйте наши услуги',
    duration: '1 день',
    durationNote: '(со дня оплаты)',
    visitingHours: 'пн-вс, 7:00 - 24:00',
    ageRestriction: 'от 14 лет',
    basePrice: 4000,
    price: 4000,
    currentQuantity: 1,
    includes: ['gym', 'pool', 'sauna'],
    isGroupClassesIncluded: false,
    selectionType: 'exclusive'
  },
  {
    id: 'bba14add-e940-11ef-80d8-ac1f6bb3f7d3',
    type: 'gift',
    title: 'Подарочная карта на 1 месяц',
    subtitle: 'Оформите карту для другого человека',
    duration: '30 дней',
    durationNote: '(со дня активации)',
    visitingHours: 'пн-вс, 7:00 - 24:00',
    basePrice: 10000,
    price: 10000,
    currentQuantity: 1,
    includes: ['gym', 'pool', 'sauna'],
    isGroupClassesIncluded: false,
    note: 'Данная карта покупается отдельно',
    selectionType: 'exclusive'
  }
];

export const getServiceIcon = (service: string): string => {
  switch (service) {
    case 'gym':
      return require('../assets/icons/gym.png');
    case 'pool':
      return require('../assets/icons/whaterpool.png');
    case 'sauna':
      return require('../assets/icons/sauna.png');
    case 'playroom':
      return require('../assets/icons/igroteka.png');
    default:
      return require('../assets/icons/gym.png');
  }
};

export const getServiceName = (service: string): string => {
  switch (service) {
    case 'gym':
      return 'Фитнес зал';
    case 'hotTub':
      return 'Бассейн';
    case 'spa':
      return 'Сауна';
    case 'playroom':
      return 'Игротека';
    default:
      return service;
  }
};

export default subscriptionsMock;

